import axios from 'axios';
import axiosInstance from '../api/axiosInstance';

const baseUrl = process.env.REACT_APP_API_URL;

export interface ApiDomainConfig {
  id: number;
  hostname: string;
  brandName: string;
  pageTitle: string;
  favicon: string;
  logos: { light: string; dark: string };
  colors: {
    primary: string;
    secondary: string;
    accent: string;
    primaryHover: string;
  };
  fontFamily: string;
  emailAccountSlug: string;
  precheckRecipients: string[];
  precheckPosRecipients: string[];
  createdAt: string;
  updatedAt: string;
}

export interface DomainConfigDto {
  hostname: string;
  brandName: string;
  pageTitle: string;
  favicon: string;
  logos: { light: string; dark: string };
  colors: {
    primary: string;
    secondary: string;
    accent: string;
    primaryHover: string;
  };
  fontFamily: string;
  emailAccountSlug: string;
  precheckRecipients: string[];
  precheckPosRecipients: string[];
}

export async function getDomainConfig(hostname: string): Promise<ApiDomainConfig> {
  const response = await axios.get(`${baseUrl}/public/domain-config`, {
    params: { hostname },
  });
  return response.data;
}

export async function getAllDomainConfigs(): Promise<ApiDomainConfig[]> {
  const response = await axiosInstance.get(`${baseUrl}/admin/domain-config`);
  return response.data;
}

export async function getDomainConfigById(id: number): Promise<ApiDomainConfig> {
  const response = await axiosInstance.get(`${baseUrl}/admin/domain-config/${id}`);
  return response.data;
}

export async function createDomainConfig(data: DomainConfigDto): Promise<ApiDomainConfig> {
  const response = await axiosInstance.post(`${baseUrl}/admin/domain-config`, data);
  return response.data;
}

export async function updateDomainConfig(id: number, data: DomainConfigDto): Promise<ApiDomainConfig> {
  const response = await axiosInstance.put(`${baseUrl}/admin/domain-config/${id}`, data);
  return response.data;
}

export async function deleteDomainConfig(id: number): Promise<void> {
  await axiosInstance.delete(`${baseUrl}/admin/domain-config/${id}`);
}
